import LocalPlayIcon from '@mui/icons-material/LocalPlay'
import { IconBox, type IIconBoxProps } from 'settle-ui/components/IconBox/IconBox'

interface IPromoCodeIconProps extends IIconBoxProps {
  active?: boolean
}

export const PromoCodeIcon: Settle.FC<IPromoCodeIconProps> = ({ active = true, ...props }) => (
  <IconBox {...props}>
    <LocalPlayIcon
      sx={{
        ...(active
          ? { color: (theme) => theme.tokens.ThemeColorCommonSecondary }
          : { color: (theme) => theme.tokens.ThemeColorCommonOnSurfaceTertiary }),
      }}
    />
  </IconBox>
)
